import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('form-loader', {
  template: require('./template.html'),
  name: 'form-loader',
  computed: {
    ...mapGetters(['activeDroplet']),
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/form/components/_preview/loader/index.js